export const ADD_CLIENT_MODAL_NAME = 'ADD_CLIENT_MODAL_NAME';
